
import { useNotasIngresoTodas } from "../../../hooks/cache";
import { CargandoMedio, ModalFormulario } from "../../components";
import { LayoutCrearDoc } from "../../layouts";
import { FormAprobarIngresoStock, TablaNotas } from "../components";
import { useModalStore, useNotasStore } from "../../../stores";
import { Box, Divider, Typography } from "@mui/material";
import { separadorMillares, useValidarRoles } from "../../../hooks";



export const NotasIngresoStock = () => {


    const { permitirXRol } = useValidarRoles();
    const isAdmin = permitirXRol('SUPERADMIN', 'ADMINISTRADOR');
    const { activarNota, setActivarNotas } = useNotasStore();
    const { modalFormToggle, tipo } = useModalStore();
    const { data, isLoading, chagePage, page, termino, chageTermino } = useNotasIngresoTodas();


    const handleCerrarModalInv = () => {
        setActivarNotas(null);
        modalFormToggle(false);
    }


    return (
        
        <LayoutCrearDoc titulo='Notas ingreso de stocks' subtitulo='información notas stocks' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de notas..." />
            :   <>
                <TablaNotas data={data || []} chagePage={chagePage} page={page} />
                </>
            }

            {(tipo === 'aprobar-item') &&
            <ModalFormulario titulo={`Aprobar Ingreso`} valor={activarNota} onClose={ handleCerrarModalInv }>
                <FormAprobarIngresoStock />
            </ModalFormulario>
            }

            {(tipo === 'ver-items') &&
            <ModalFormulario titulo={`Detalles Items`} valor={activarNota} onClose={ handleCerrarModalInv }>
                {activarNota?.gasto?.items.map(item => (
                    <Box key={item?.producto?._id} sx={{ mb: 1.5 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            { item.producto?.nombre }
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Cantidad: { item.cantidad }
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Unidad Medida: { item?.producto?.medida?.nombre }
                        </Typography>

                        {(isAdmin) && 
                        <Typography variant="body2" fontWeight="bold">
                            {`Total: $${separadorMillares(item.total)}`}
                        </Typography>
                        }
                        <Divider sx={{ mt: 1 }} />
                    </Box>
                ))}
            </ModalFormulario>
            }

        </LayoutCrearDoc>
    )
}
